import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.aktion-lese-berechtigung';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAktionLeseBerechtigungEffects {

    AktionLeseBerechtigung$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_AKTION_LESE_BERECHTIGUNG),
        mergeMap((x: ac.GetAktionLeseBerechtigungAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getAktionLeseBerechtigung(x.veranstaltung_id, x.aktionId).pipe(
                map((result: any) => {
                    return new ac.GetAktionLeseBerechtigungErfolgreichAction(result, x.veranstaltung_id, x.aktionId, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetAktionLeseBerechtigungFehlerAction(error, x.veranstaltung_id, x.aktionId, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AktionenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AktionenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AktionenQueryService);
        }
        return this.service;
    }
}
